import React from "react";
import { IoIosArrowDown } from "react-icons/io";

import RecentTransactions from "../../components/super-admin/dashbaord/RecentTransactions.jsx";
import Superdashboard from "../../components/super-admin/dashbaord/Superdashboard.jsx";
import CompaniesChart from "../../components/super-admin/dashbaord/CompaniesChart.jsx";
import RevenueChart from "../../components/super-admin/dashbaord/RevenueChart.jsx";
import TopPlansChart from "../../components/super-admin/dashbaord/TopPlansChart.jsx";
import { Container, Row, Col } from "react-bootstrap";
import RecentTransactionsCard from "../../components/super-admin/dashbaord/RecentTransactionsCard .jsx";
import RecentlyRegisteredCard from "../../components/super-admin/dashbaord/RecentlyRegisteredCard.jsx";
import RecentPlanExpiredCard from "../../components/super-admin/dashbaord/RecentPlanExpiredCard.jsx";

const DashboardPage = () => {
  return (
    <div style={{ padding: "15px", background: "#f8f9fa",  }}>
      <Superdashboard />

<Container className="mx-2"  style={{ background: "#f4f6f9" }}>
  <Row className="gx-4 gy-4">
    <Col xxl={4} xl={6} lg={6} md={12}>
      <CompaniesChart />
    </Col>

    <Col xxl={4} xl={6} lg={6} md={12}>
      <RevenueChart />
    </Col>

    <Col xxl={4} xl={6} lg={6} md={12}>
      <TopPlansChart />
    </Col>
  </Row>
</Container>

      <Row className="g-2 mt-4 mx-2 ">
        <Col xxl={4} xl={12} className="d-flex ">
          <RecentTransactionsCard />
        </Col>

        <Col xxl={4} xl={6} className="d-flex ">
          <RecentlyRegisteredCard />
        </Col>

        <Col xxl={4} xl={6} className="d-flex ">
          <RecentPlanExpiredCard />
        </Col>
      </Row>
      {/* <RecentTransactions/> */}
    </div>
  );
};

export default DashboardPage;
